import { IError } from '@checkout/errors';
import { IAddVoucherSuccessPayload, IRemoveVoucherSuccessPayload } from '@checkout/payloadTypes';
import { RootState } from '@checkout/state';
import { AxiosResponse } from 'axios';
import { Epic } from 'redux-observable';
import 'rxjs/add/observable/concat';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/mergeMapTo';
import 'rxjs/add/operator/switchMap';
import { fromPromise as fromPromise$ } from 'rxjs/observable/fromPromise';
import { of as of$ } from 'rxjs/observable/of';
import { RootAction } from '../actions/actionTypes.d';
import { rest } from '../utils/apiUtils';
import { logger } from '../utils/logger';
import { kcoResume, kcoSuspend } from '../utils/widgets';
// import { isKlarnaCheckout } from '../utils/paymentMethods';
import ActionTypes from './../actions/actionTypes';
import { AddVoucherRequestAction, RemoveVoucherRequestAction } from './../actions/actionTypes.d';
import { addVoucherError, addVoucherSuccess, clearVoucherError, removeVoucherSuccess, setErrors } from './../reducers/checkout';

export const addVoucherEpic: Epic<RootAction, RootAction, RootState> =
  (action$, state$) => action$
    .ofType(ActionTypes.ADD_VOUCHER_REQUEST)
    .do(() => { kcoSuspend(); })
    .mergeMap((action: AddVoucherRequestAction) => {
      return fromPromise$(rest.httpPost('/vouchers', { voucher: action.payload }))
        .flatMap((payload: AxiosResponse<IAddVoucherSuccessPayload>) => {
          kcoResume();
          return of$(addVoucherSuccess(payload.data));
        })
        // @ts-ignore
        .catch((error: IError) => {
          kcoResume();
          logger(error);
          if (error.response && error.response.data) {
            return of$(addVoucherError(error.response.data.errors.voucher));
          }
          return of$(setErrors(error));
        });
    });

export const removeVoucherEpic: Epic<RootAction, RootAction, RootState> =
    (action$, state$) => action$
      .ofType(ActionTypes.REMOVE_VOUCHER_REQUEST)
      .do(() => { kcoSuspend(); })
      .mergeMap((action: RemoveVoucherRequestAction) => {
        return fromPromise$(rest.httpDelete('/vouchers', { voucher: action.payload }))
          .flatMap((payload: AxiosResponse<IRemoveVoucherSuccessPayload>) => {
            kcoResume();
            return of$(removeVoucherSuccess(payload.data));
          })
          .catch((error: IError) => {
            kcoResume();
            logger(error);
            return of$(setErrors(error));
          });
      });

export const clearVoucherErrorsEpic: Epic<RootAction, RootAction, RootState> = (action$, state$) =>
  action$.ofType(ActionTypes.ADD_VOUCHER_ERROR)
    .delay(5000)
    .mergeMapTo(of$(clearVoucherError()));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/voucher.ts